var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 224 130",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M223.132 120.715V101.944L0.999954 101.944V120.715L22.434 129.7H201.714L223.132 120.715Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M223.132 68.4923V99.5189L0.999954 99.5189V68.4923L223.132 68.4923Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M76.4637 73.9448V97.0311L14.4973 80.1122H8.42418L3.42285 85.9168L3.42285 90.7752L8.42418 97.0311H62.7245",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M149.505 73.9447V97.031L87.5383 80.1121H81.4652L76.4639 85.9167V90.7751L81.4652 97.031H135.766",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M222.023 96.8882L222.546 97.0309L160.579 80.1121H154.506L149.505 85.9166V90.7751L154.506 97.0309H208.807",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M223.132 92.8932V110.337L216.401 113.202L207.718 107.413L200.192 113.202H181.379L175.012 107.413L163.145 114.939L147.515 110.337L137.964 113.202L121.625 108.505L99.3045 114.939L89.0493 104.23L80.9452 113.202H67.4823L58.7147 107.413L47.0812 114.939L34.925 107.413L25.663 113.202H11.4807L8.00749 107.413L0.999969 110.337V92.8932L8.00749 89.5585L16.3188 96.4839L23.1029 89.5585L39.1161 85.1846L47.0812 92.8932L60.2084 89.5882L67.4823 99.4924H74.2092L75.1078 89.5882L112.066 92.8932L132.327 90.5545L137.964 97.5844L147.515 91.8809L161.996 97.5844L166.906 90.5545H186.247L193.741 96.4839L206.931 89.5882L218.453 93.9849L223.132 92.8932Z",
          fill: "#179E7E"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M4.58496 103.361L11.8208 100.756L15.2941 107.992H22.2405L26.8715 98.4408L37.2911 96.7042L41.0538 103.361L49.7368 107.992L53.4995 100.756L61.6037 98.4408L67.103 105.387L77.5226 107.992L82.443 96.7042L95.4676 98.4408L101.546 107.992L113.702 105.387L117.754 98.4408L128.753 96.7042L131.936 103.361L139.751 105.387L144.961 100.756L155.091 103.361L157.407 107.992L169.563 105.387L171.589 98.4408L183.456 96.7042L187.797 103.361L197.059 105.387L203.137 100.756H212.978L220.214 107.992",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M104.553 64.5281H1L1 71.3759L52.6318 96.9452L104.553 71.3759V64.5281Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M223.131 64.5281H119.578V71.3759L171.21 96.9452L223.131 71.3759V64.5281Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M169.466 62.2902L54.0801 62.2902V69.9204L111.612 98.4114L169.466 69.9204V62.2902Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M148.271 65.6745V49.3649H73.2106V65.6745L88.6242 71.9182H132.833L148.271 65.6745Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M148.271 56.0463L132.833 62.2899H88.6242L73.2106 56.0463",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M93.4792 29.9998V44.5115L104.573 52.0603H123.595L134.688 44.5115V29.9998H141.214V56.2406L126.607 66.1803H101.56L86.9531 56.2406V29.9998H93.4792Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M93.4792 20.6436V44.5124L104.573 52.0611H123.595L134.688 44.5124V20.6436H141.214V46.8844L126.607 56.8241H101.56L86.9531 46.8844V20.6436H93.4792Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "1.73516",
          height: "31.4176",
          transform: "matrix(-1 0 0 1 141.214 20.6428)",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "1.73516",
          height: "31.4176",
          transform: "matrix(-1 0 0 1 88.6885 20.6428)",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M223.132 65.6745V49.3649H148.071V65.6745L163.485 71.9182H207.693L223.132 65.6745Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M223.132 56.0463L207.693 62.2899H163.485L148.071 56.0463",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M168.34 29.9998V44.5115L179.433 52.0603H198.455L209.548 44.5115V29.9998H216.074V56.2406L201.467 66.1803H176.42L161.813 56.2406V29.9998H168.34Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M168.34 20.6436V44.5124L179.433 52.0611H198.455L209.548 44.5124V20.6436H216.074V46.8844L201.467 56.8241H176.42L161.813 46.8844V20.6436H168.34Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "1.73516",
          height: "31.4176",
          transform: "matrix(-1 0 0 1 216.074 20.6428)",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "1.73516",
          height: "31.4176",
          transform: "matrix(-1 0 0 1 163.549 20.6428)",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M73.4111 65.6745V49.3649H1.00024V65.6745L15.8697 71.9182H58.5177L73.4111 65.6745Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M73.4111 56.0461L58.5177 62.2898H15.8697L1.00024 56.0461",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M14.1042 29.9998V44.5115L24.8059 52.0603H43.1564L53.8581 44.5115V29.9998H60.1538V56.2406L46.0625 66.1803H21.8998L7.80859 56.2406L7.80859 29.9998H14.1042Z",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M14.1052 20.6448V44.5136L24.8069 52.0623H43.1574L53.8591 44.5136V20.6448H60.1548V46.8856L46.0635 56.8253H21.9008L7.80957 46.8856L7.80957 20.6448H14.1052Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "1.6739",
          height: "31.4176",
          transform: "matrix(-1 0 0 1 60.1533 20.6427)",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "1.6739",
          height: "31.4176",
          transform: "matrix(-1 0 0 1 9.48242 20.6427)",
          fill: "#802EEA"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M223.132 22.9076V49.3649L0.999954 49.3649V22.9076L51.3775 0L172.771 0L223.132 22.9076Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M42.5752 12.5943L82.4206 2.88843",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M110.61 12.5943L150.456 2.88843",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M67.9365 12.5942L107.782 2.88831",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M135.972 12.594L175.817 2.88818",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M223.132 49.365L0.999959 49.365",
          stroke: "black",
          "stroke-width": "2"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }